var _excluded = ["label", "main", "aside"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import ConditionalWrapper from "../../../../helpers/ConditionalWrapper";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import breakpoint from "../../../../utils/breakpoint";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getBoxShadow from "../../../../utils/getBoxShadow";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import { horizontalGutterSpace, backgroundColor, shadowSize, borderRadiusSize } from "../settings";
var Wrapper = styled.div.withConfig({
  componentId: "sc-5dvrlh-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:grid;grid-gap:", ";grid-template-columns:auto auto;align-items:center;justify-content:space-between;margin-bottom:", ";padding:", ";background-color:", ";box-shadow:", ";&:last-child{margin-bottom:0;border-bottom-right-radius:", ";border-bottom-left-radius:", ";}", "{grid-template-columns:auto 1fr auto;padding:", " ", ";}"], space(horizontalGutterSpace), unit(2), space(2), getColor(theme, backgroundColor), getBoxShadow(theme, shadowSize), getBorderRadius(theme, borderRadiusSize), getBorderRadius(theme, borderRadiusSize), breakpoint("medium"), space(2), space(3));
});
var Label = styled.div.withConfig({
  componentId: "sc-5dvrlh-1"
})(["margin-bottom:", ";", "{margin-bottom:0;}"], space(1), breakpoint("medium"));
function SubItem(_ref2) {
  var label = _ref2.label,
    main = _ref2.main,
    aside = _ref2.aside,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  return /*#__PURE__*/React.createElement(Wrapper, restProps, /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: isSmallOnly,
    wrapper: function wrapper(content) {
      return /*#__PURE__*/React.createElement("div", null, content);
    }
  }, /*#__PURE__*/React.createElement(Label, null, label), main), aside);
}
export default SubItem;